import { render, staticRenderFns } from "./RouterWrap.vue?vue&type=template&id=67388db5&scoped=true"
import script from "./RouterWrap.vue?vue&type=script&lang=js"
export * from "./RouterWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67388db5",
  null
  
)

export default component.exports